import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { breakpoints } from 'utils/utils'
import { IoIosClose } from 'react-icons/io'
import Img from 'gatsby-image'

export default props => {
    
    const data = useStaticQuery(graphql`
        query{
            allContentfulHomePopup {
                edges {
                    node {        
                        title
                        image {
                            title
                            fluid {
                                ...GatsbyContentfulFluid
                            }
                        }
                        text {
                            text
                        }       
                        link {
                            href
                            value
                        }
                        footerText
                        logos {
                            title
                            fluid {
                                ...GatsbyContentfulFluid
                            }
                            file {
                                url
                            }
                        }
                        enabled
                    }
                }
            }
        }
    `)

    const [show, setShow] = useState();

    useEffect(() => {
        const checkCookie = () => {
            var showHomePopup = getCookie("showHomePopup");
            if (showHomePopup === "false") {            
                setShow(false);
            } else {
                setShow(true);
            }
        }
        if(document.cookie.match(/^(.*;)?\s*cookieSettings\s*=\s*[^;]+(.*)?$/)) {
            const cookie = getCookie("cookieSettings")
            const cookieSettings = JSON.parse(cookie)
            if(cookieSettings['technical'] === true) {
                if(!document.cookie.match(/^(.*;)?\s*showHomePopup\s*=\s*[^;]+(.*)?$/)) {
                    document.cookie = "showHomePopup=true";
                    setShow(true);
                } else {
                    checkCookie();
                }
            }
        } else {
            setShow(true);
        }

    },[]);


    const getCookie = (cname) => {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

    const popupInfo = data.allContentfulHomePopup.edges[0].node;
    const { title, image, text, link, logos, footerText, enabled } = popupInfo;

    const closePopup = () => {
        if(document.cookie.match(/^(.*;)?\s*cookieSettings\s*=\s*[^;]+(.*)?$/)) {
            const cookie = getCookie("cookieSettings")
            const cookieSettings = JSON.parse(cookie)
            if(cookieSettings['technical'] === true) {
                document.cookie = "showHomePopup=false";
            }
        }
        setShow(false);        
    }

    return (
        <>
        {
            enabled && show &&
            <>
                <Overlay onClick={closePopup}/>
                <Container>
                    <Wrapper>
                        <Close onClick={closePopup}>
                            <IoIosClose />
                        </Close>
                        <Title>{title}</Title>
                        <Content>
                            <ContentText dangerouslySetInnerHTML={{__html: text && text.text}}></ContentText>
                            <SetImg fluid={ image.fluid } />                   
                        </Content>
                        <LinkPopup href={link.href}>{link.value}</LinkPopup>
                        <Footer>
                            <FooterText>{footerText}</FooterText>
                            {
                                logos &&
                                <>
                                    {
                                        logos.map((logo, index) => 
                                            logo.fluid ?
                                                <Logo key={`Logo${index}`} fluid={logo.fluid} alt={logo.title}/>
                                            :
                                                <img key={`Logo${index}`} src={logo.file.url} alt={logo.title}/>
                                        )
                                    }
                                </>
                            }
                        </Footer>
                    </Wrapper>               
                </Container>
            </>
        }
        </>
    )
}

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    height: fill-available;
    cursor: pointer;
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99999999990;
`
const Container = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    width: 100%;
    max-width: 52rem;
    height: auto;
    transform: translate(-50%, -50%);
    background-color: #FFF;
    z-index: 99999999999;    
`

const Wrapper = styled.div`
    position: relative;
    padding: 1.5rem;
`

const Close = styled.button`
    cursor: pointer;
    position: absolute;
    top: 1rem;
    right: 1rem;
    background-color: transparent;
    border: 0;

    svg {
        width: 3rem;
        height: 3rem;
    }
`

const Title = styled.h3`
    width: fit-content;
    margin-top: 0;
    padding: 1rem;
    border-radius: .5rem;
    color: #FFF;
    background-color: red;
    font-weight: 700;
`

const Content = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`

const ContentText = styled.div`
    width: 50%;

    ul {
        padding: 0;
    }

    li {
        margin: .5rem 0;
        span {

            font-weight: 700;
        }
    }
    ${breakpoints.ms} {
        width: 100%;
    }

`

const SetImg = styled(Img)`
    width: 50%;
    height: auto;
    ${breakpoints.ms} {
        display: none;
    }
`

const LinkPopup = styled.a`
    position: absolute;
    bottom: 12%;
    right: 20%;
    width: fit-content;
    padding: 1rem;
    border-radius: .5rem;
    color: #FFF;
    background-color: red;
    font-size: 1.2rem;
    font-weight: 700;

    ${breakpoints.sm} {
        position: unset;
    margin: 0 auto 1rem;
    display: block;
    }
`

const Footer = styled.div`
    img {
        height: 1.5rem;
        width: auto;
        vertical-align: middle;
        margin-right: .5rem;
    }
`

const FooterText = styled.span`
`

const Logo = styled(Img)`
`
